import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
export const ButtonsContainer = styled.div `
  width: 100%;
`;
export const ButtonsWrapper = styled.div `
  padding: 18px 15px;
  background-color: ${newColors.snow};
  border-radius: 18px;
  border: 1px solid ${newColors.gray100dot30};
  box-shadow: 0px 4px 26px 0px ${newColors.darkBlackAlpha};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 965px;

  ${mediaq.sm `
    padding: 10px 15px;
    flex-direction: column;
    align-items: flex-end;
  `}
`;
export const CommercialLink = styled.a `
  border-right: 1px solid ${newColors.gray100};
  text-decoration: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  ${mediaq.sm `
    border-right: 0;
    border-bottom: 1px solid ${newColors.gray100};
    flex-direction: column;
    align-items: flex-end;
justify-content: space-between;
  `}

  &:last-of-type {
    border: 0;
  }
`;
export const PlanAheadButton = styled.div `
  border-right: 1px solid ${newColors.gray100};
  text-decoration: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  ${mediaq.sm `
    border-right: 0;
    border-bottom: 1px solid ${newColors.gray100};
    flex-direction: column;
    align-items: flex-end;
justify-content: space-between;
  `}

  &:last-of-type {
    border: 0;
  }
`;
export const CommercialLinksContainer = styled.div `
  text-align: center;
  width: 100%;
`;
